/**
 * @generated SignedSource<<b34fa9fddd739a79f19b6b1fd69824d4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appSubscriptionCheck$data = {
  readonly isAdminUser: boolean;
  readonly isSellerMigrating: boolean;
  readonly productSwitcherTasks: ReadonlyArray<{
    readonly extraData: {
      readonly paymentMethodSetupTaskID: number | null;
    };
    readonly state: number;
    readonly taskType: string;
  }> | null;
  readonly subscription: {
    readonly isCancelled: boolean;
  } | null;
  readonly " $fragmentType": "appSubscriptionCheck";
};
export type appSubscriptionCheck$key = {
  readonly " $data"?: appSubscriptionCheck$data;
  readonly " $fragmentSpreads": FragmentRefs<"appSubscriptionCheck">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appSubscriptionCheck",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAdminUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ZakekeSubscription",
      "kind": "LinkedField",
      "name": "subscription",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCancelled",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSellerMigrating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSwitcherTask",
      "kind": "LinkedField",
      "name": "productSwitcherTasks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSwitcherTaskExtraData",
          "kind": "LinkedField",
          "name": "extraData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paymentMethodSetupTaskID",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "f8378a67887449c173dc6a8734fb9f75";

export default node;
